import { ETicketStatus } from '@constants';
import styled from 'styled-components';

import { TICKET_LABEL_STATUS_COLORS, TICKET_STATUS_COLORS } from '@/constants';

export const SelectorWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  text-align: center;
`;

export const StatusWrapper = styled.div<{ $status: ETicketStatus }>`
  cursor: pointer;
  flex-shrink: 0;

  & > :first-child {
    padding: 3px 7px;
    font-weight: 400;
    border-radius: 5px;
    font-size: 14px;

    color: ${({ $status }) => TICKET_LABEL_STATUS_COLORS[$status]};
    background-color: ${({ $status }) => TICKET_STATUS_COLORS[$status]};
    justify-content: flex-start;
  }
`;

export const StatusTextWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
`;

export const Label = styled.span`
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  color: ${({ theme }) => theme.colors.black6};
`;
